module.exports = __webpack_public_path__ + "assets/img/246601.083eca4e.png";